import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider } from './context/AuthContext';
import { Toaster } from 'sonner';

// Layout
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';

// Pages
import HomePage from './pages/HomePage';
import BusinessDirectory from './pages/BusinessDirectory';
import MinorityOwned from './pages/MinorityOwned';
import BusinessDetail from './pages/BusinessDetail';
import EventsCalendar from './pages/EventsCalendar';
import EventDetail from './pages/EventDetail';
import Register from './pages/Register';
import CommunityLogin from './pages/CommunityLogin';
import BusinessLogin from './pages/BusinessLogin';
import AdminLogin from './pages/AdminLogin';
import CommunityAccount from './pages/CommunityAccount';
import BusinessAccount from './pages/BusinessAccount';
import AdminDashboard from './pages/AdminDashboard';
import SubmitBusiness from './pages/SubmitBusiness';
import SubmitEvent from './pages/SubmitEvent';
import FeatureMyBusiness from './pages/FeatureMyBusiness';
import FeatureMyEvent from './pages/FeatureMyEvent';
import ContactUs from './pages/ContactUs';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsConditions from './pages/TermsConditions';
import Pricing from './pages/Pricing';
import HowTo from './pages/HowTo';
import VerifyEmail from './pages/VerifyEmail';
import VerifyReview from './pages/VerifyReview';

import './App.css';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function App() {
  return (
    <HelmetProvider>
    <AuthProvider>
      <BrowserRouter>
        <ScrollToTop />
        <div className="min-h-screen flex flex-col bg-neutral-50">
          <Navbar />
          <main className="flex-1">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/businesses" element={<BusinessDirectory />} />
              <Route path="/businesses/:slug" element={<BusinessDetail />} />
              <Route path="/minority-owned" element={<MinorityOwned />} />
              <Route path="/events" element={<EventsCalendar />} />
              <Route path="/events/:slug" element={<EventDetail />} />
              <Route path="/register" element={<Register />} />
              <Route path="/community-login" element={<CommunityLogin />} />
              <Route path="/business-login" element={<BusinessLogin />} />
              <Route path="/admin-login" element={<AdminLogin />} />
              <Route path="/community-account" element={<CommunityAccount />} />
              <Route path="/business-account" element={<BusinessAccount />} />
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/submit-business" element={<SubmitBusiness />} />
              <Route path="/submit-event" element={<SubmitEvent />} />
              <Route path="/feature-my-business" element={<FeatureMyBusiness />} />
              <Route path="/feature-my-event" element={<FeatureMyEvent />} />
              <Route path="/contact" element={<ContactUs />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms-conditions" element={<TermsConditions />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/how-to" element={<HowTo />} />
              <Route path="/verify-email" element={<VerifyEmail />} />
              <Route path="/verify-review" element={<VerifyReview />} />
            </Routes>
          </main>
          <Footer />
        </div>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
